import { Link } from 'react-router-dom';
import { useAuthStore } from '../auth/useAuthStore';
import { usePortalAccess } from './PortalAccessContext';
import './dashboard.css';

/**
 * Tira superior compartida por TODAS las pantallas del portal (Inicio,
 * Sistema de Transporte, Línea, Mapa del sistema) — mismo logo (enlazado a
 * `/`), misma marca, mismo bloque de usuario/cerrar sesión. Extraído del
 * markup que ya usaban `ClientPortalDashboard`/`AnalysisHubPage`
 * (duplicado idéntico en ambas) — reutiliza `dashboard.css` (`db-topbar*`)
 * en vez de crear una barra nueva. Cada pantalla sigue poniendo su propio
 * contexto (breadcrumb, título, back-link) debajo, en su propio markup.
 */
export function PortalTopbar(): JSX.Element {
  const { config } = usePortalAccess();
  const { user, logout } = useAuthStore();

  return (
    <header className="db-topbar">
      <Link to="/" className="db-topbar-brand">
        <img src="/assets/brand/sintax-logo-negativo.svg" alt="Sintax" />
        <span>{config?.title ?? 'Portal SINTAX'}</span>
      </Link>
      <div className="db-topbar-user">
        {user && <span>{user.fullName}</span>}
        <button onClick={() => logout()}>Cerrar sesión</button>
      </div>
    </header>
  );
}
